import { makeRequest } from 'utils/requestLogger';

export default (poll_id) =>
  makeRequest('delete', `/api/polls/${poll_id}/delete`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/deletePoll.js